export default "__VITE_ASSET__dc3009da__"